export default __webpack_public_path__ + "static/media/hybrid-app.13ac1534.svg";